import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL + 'cities';

// Get token from localStorage
const getToken = () => localStorage.getItem('token');

// Create axios instance with auth header
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const cityService = {
  // Get all cities
  getCities: async () => {
    const response = await axiosInstance.get('/');
    return response.data;
  },

  // Create new city
  createCity: async (cityData) => {
    const response = await axiosInstance.post('/', cityData);
    return response.data;
  },

  // Update city
  updateCity: async (id, cityData) => {
    const response = await axiosInstance.put(`/${id}`, cityData);
    return response.data;
  },

  // Delete city
  deleteCity: async (id) => {
    const response = await axiosInstance.delete(`/${id}`);
    return response.data;
  },

  // Update cities order
  updateOrder: async (cities) => {
    const response = await axiosInstance.put('/reorder', { cities });
    return response.data;
  }
};
